// Auto-submit ke Apps Script saat landing di halaman contact, payload sama seperti waba-trigger.js (click event)

import { VisitorID } from './visitor-id.js'; // optional, jika ingin memastikan visitor_id sudah ada
import { getCookie, setCookie, updateCookie, text_truncate, getBrowserType } from '../core/utils.js';

const ContactAutoTrack = {
  endpoint: 'https://script.google.com/macros/s/AKfycbwpZd_n25ih7juD-Sm0OyGjjDD4ZCCTqTFPzAh4hck1M0F9KRnubhhqse1JN4tr7R5ELQ/exec',
  targets: ['/id/hubungi-kami', '/en/contact-us'],

  sentKeyForPath() {
    const path = window.location.pathname.replace(/\/+$/, '');
    return `contact_auto_sent:${path}`;
  },

  shouldSend() {
    const path = window.location.pathname.replace(/\/+$/, '');
    const isTarget = this.targets.includes(path);
    if (!isTarget) return false;

    // Suppress on refresh/reload of the same page
    const nav = (performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation')[0] : undefined;
    const isReload = nav && nav.type === 'reload';
    if (isReload) {
      console.log('[ContactAutoTrack] shouldSend: navigation is reload, suppress');
      return false;
    }

    // Allow multiple sends in a session if coming from a different page.
    // If referrer is the same path (same-page link or re-navigation to same URL), suppress.
    let refPath = '';
    try {
      if (document.referrer) {
        const refUrl = new URL(document.referrer);
        refPath = refUrl.pathname.replace(/\/+$/, '');
      }
    } catch {}
    console.log('[ContactAutoTrack] shouldSend: referrer path =', refPath, ', current path =', path);
    if (refPath && refPath === path) {
      console.log('[ContactAutoTrack] shouldSend: same referrer path as current, suppress');
      return false;
    }

    // Otherwise send
    return true;
  },

  // Util yang sama dengan asumsi fungsi-fungsi cookie ada secara global
  getBrowserType() {
    // Jika sudah ada getBrowserType() global, gunakan itu
    if (typeof getBrowserType === 'function') return getBrowserType();
    // Fallback sederhana
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes('chrome')) return 'Chrome';
    if (ua.includes('safari')) return 'Safari';
    if (ua.includes('firefox')) return 'Firefox';
    return 'Unknown';
  },

  text_truncate(str, length, ending = '') {
    if (typeof text_truncate === 'function') return text_truncate(str, length, ending);
    if (!str) return '';
    if (str.length <= length) return str;
    return str.substring(0, length) + ending;
  },

  // Isi field persis seperti snippet waba-trigger.js
  fillFields() {
    console.log('[ContactAutoTrack] fillFields: start');
    // Pastikan visitor_id dibuat/ada jika kamu ingin dipakai di tempat lain
    try { VisitorID.init(); } catch (e) {}

    const browserType = this.getBrowserType();
    const url_string = window.location.href;
    const url = new URL(url_string);

    let devicetype = 'Desktop';
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      devicetype = 'Mobile';
    }

    const click_date = new Date();
    const click_DD = (click_date.getDate() < 10 ? '0' : '') + click_date.getDate();
    const click_MM = ((click_date.getMonth() + 1) < 10 ? '0' : '') + parseInt(click_date.getMonth() + 1);
    const click_YY = click_date.getFullYear().toString().slice(2);
    const click_hh = (click_date.getHours() < 10 ? '0' : '') + click_date.getHours();
    const click_mm = (click_date.getMinutes() < 10 ? '0' : '') + click_date.getMinutes();
    const click_ss = click_date.getSeconds();
    const click_ms = click_date.getMilliseconds();
    const click_sh = click_DD + click_MM + click_YY + click_hh + click_mm + click_ss + click_ms;

    const gclid = url.searchParams.get('gclid') || getCookie('gclid') || '';
    const msclkid = url.searchParams.get('msclkid') || getCookie('msclkid') || '';
    const umedium = url.searchParams.get('utm_medium') || getCookie('utm_medium') || '';
    const ucampaign = url.searchParams.get('utm_campaign') || getCookie('utm_campaign') || '';
    const usource = url.searchParams.get('utm_source') || getCookie('utm_source') || '';
    const utm_term = url.searchParams.get('utm_term') || getCookie('utm_term') || '';
    const matchtype = url.searchParams.get('matchtype') || getCookie('matchtype') || '';
    const banner_journey = getCookie('banner_journey') || '';
    const cta_journey = getCookie('cta_journey') || '';
    const cta_last_click = getCookie('cta_last_click') || '';
    const medium_code = getCookie('waba_code') || '';
    const campaign_code = getCookie('medium_code') || '';
    const query_keyword = url.searchParams.get('query') || getCookie('query_keyword') || 'null';

    // Select element sesuai snippet
    const f_gclid_short = document.querySelector('#f_gclid_short');
    const f_gclid = document.querySelector('#f_gclid');
    const f_device = document.querySelector('#f_device');
    const f_utmsource = document.querySelector('#f_utmsource');
    const f_utmmedium = document.querySelector('#f_utmmedium');
    const f_utmcampaign = document.querySelector('#f_utmcampaign');
    const f_utmterm = document.querySelector('#f_utmterm');
    const f_banner_id = document.querySelector('#f_banner_id');
    const f_gclid_journey = document.querySelector('#f_gclid_journey');
    const f_matchtype = document.querySelector('#f_matchtype');
    const f_journey = document.querySelector('#f_journey');
    const f_gaid = document.querySelector('#f_gaid');
    const f_waba_medium = document.querySelector('#f_waba_medium');
    const f_browser = document.querySelector('#f_browser');
    const f_referrer = document.querySelector('#f_referrer');
    const f_label = document.querySelector('#f_label');
    const f_query_keyword = document.querySelector('#f_query_keyword');
    const f_visitor_id = document.querySelector('#f_visitor_id');

    if (f_gclid_short) f_gclid_short.setAttribute('value', click_sh);
    if (f_gclid) f_gclid.setAttribute('value', this.text_truncate(`${gclid}|${msclkid}`, 250, ''));
    if (f_utmsource) f_utmsource.setAttribute('value', usource);
    if (f_utmmedium) f_utmmedium.setAttribute('value', umedium);
    if (f_utmcampaign) f_utmcampaign.setAttribute('value', ucampaign);
    if (f_utmterm) f_utmterm.setAttribute('value', utm_term);
    if (f_matchtype) f_matchtype.setAttribute('value', matchtype);
    if (f_banner_id) f_banner_id.setAttribute('value', banner_journey);
    if (f_query_keyword) f_query_keyword.value = query_keyword;
    if (f_visitor_id) f_visitor_id.value = getCookie('visitor_id') || '';

    // Bagian label/cta_journey: karena tidak ada this dari click, kita tidak bisa ambil this.id / innerText.
    // Di landing, kita tambahkan entry info "Landing Auto" agar format tetap konsisten.
    let label = 'ID: , Label: Landing Auto';
    let cta_journey_temp = '';
    if (cta_journey !== '') {
      cta_journey_temp = cta_journey + '|' + label;
    } else {
      cta_journey_temp = label;
    }
    if (f_label) f_label.value = cta_journey_temp;

    if (getCookie('cta_journey')) {
      updateCookie('cta_journey', cta_journey_temp);
    } else {
      setCookie('cta_journey', cta_journey_temp, 31);
    }

    // Karena bukan click, jangan ubah cta_last_click

    if (f_gclid_journey) {
      f_gclid_journey.setAttribute('value', (getCookie('gclid_journey') ? getCookie('gclid_journey') : ''));
    }

    if (f_device) {
      f_device.setAttribute('value', devicetype);
    }

    const form_waba = document.querySelector('#form_shortener_gclid');
    if (form_waba) {
      console.log('[ContactAutoTrack] form detected: #form_shortener_gclid');
      if (f_journey) {
        const limit_journey = this.text_truncate(getCookie('user_journey'), 250, '');
        f_journey.setAttribute('value', limit_journey);
      }

      if (f_gaid) {
        if (getCookie('gaid')) {
          f_gaid.setAttribute('value', getCookie('gaid'));
        } else {
          if (getCookie('_ga')) {
            f_gaid.setAttribute('value', getCookie('_ga').slice(6));
          }
        }
      }

      const modifiedCampaign = '[Req.J' + click_sh + ']';
      const campaignInfo = JSON.parse('{"gclid":"' + (getCookie('gclid') ? getCookie('gclid') : '') + '", "utm_source":"' + (getCookie('utm_source') ? getCookie('utm_source') : '') + '", "utm_medium":"' + (getCookie('utm_medium') ? getCookie('utm_medium') : '') + '", "utm_campaign":"' + modifiedCampaign + '"}');

      const stringifyCampaignInfo = JSON.stringify(campaignInfo);
      const cookiesCampaignInfo = encodeURIComponent(stringifyCampaignInfo);

      if (getCookie('created_at')) {
        updateCookie('campaign_info', cookiesCampaignInfo);
        updateCookie('j_campaign_info', cookiesCampaignInfo);
      } else {
        setCookie('campaign_info', cookiesCampaignInfo, 31);
        setCookie('j_campaign_info', cookiesCampaignInfo, 31);
      }

      if (f_browser) {
        f_browser.value = browserType;
      }

      if (f_waba_medium && medium_code) {
        f_waba_medium.setAttribute('value', medium_code);
      }

      if (getCookie('lead_referrer')) {
        if (f_referrer) {
          f_referrer.value = getCookie('lead_referrer');
        }
      }
    }
    const form = document.forms['form-shortener-gclid'];
    console.log('[ContactAutoTrack] fillFields: done, form exists =', !!form);
    return { form };
  },

  async send() {
    console.log('[ContactAutoTrack] send: preparing to submit');
    const { form } = this.fillFields();
    if (!form) return;

    try {
      const res = await fetch(this.endpoint, { method: 'POST', body: new FormData(form) });
      console.log('[ContactAutoTrack] send: request sent, status =', res && res.status);
    } catch (e) {
      console.error('[ContactAutoTrack] send: request failed', e);
      // swallow error; tetap tandai sent agar tidak spam
    } finally {
      sessionStorage.setItem(this.sentKeyForPath(), '1');
      console.log('[ContactAutoTrack] send: flagged as sent for path');
      // Sembunyikan loader bila ada, mirip snippet
      requestAnimationFrame(() => {
        document.querySelectorAll('.has-loading').forEach(el => { el.style.display = 'none'; });
      });
    }
  },

  init() {
    console.log('[ContactAutoTrack] init: path =', window.location.pathname);
    if (this.shouldSend()) {
      console.log('[ContactAutoTrack] init: shouldSend = true, sending now');
      this.send();
    } else {
      console.log('[ContactAutoTrack] init: shouldSend = false (either not target page or already sent)');
    }
  }
};

export { ContactAutoTrack };